module.exports = __webpack_public_path__ + "img/icon-t3.6a37e980.png";